import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { first } from "rxjs/operators";

import { IConfiguration } from "../_models/configuration/IConfiguration";
import { ConfigurationService } from "./configuration.service";
import { AuthenticationService } from "./authentication.service";
import { UserIdleService } from "angular-user-idle";

@Injectable({
  providedIn: "root",
})
export class IdleService {
  started = false;
  isLandingPage = false;

  constructor(
    private authenticationService: AuthenticationService,
    private userIdleService: UserIdleService,
    private configurationService: ConfigurationService
  ) {}

  start() {
    this.started = true;
    this.configurationService
      .getConfig("sessionDuration")
      .pipe(first())
      .subscribe(
        (res: IConfiguration) => {
          const idleTime = isNaN(Number(res.value)) ? 1790 : Number(res.value); // secunde
          this.set(idleTime);
        },
        (error) => {
          return throwError(error);
        }
      );
  }

  private set(idleTime: number) {
    this.userIdleService.stopWatching();
    this.userIdleService.setConfigValues({
      idle: idleTime,
      timeout: 1,
    });
    this.userIdleService.startWatching();
    this.userIdleService.onTimerStart().subscribe();
    this.userIdleService.onTimeout().subscribe(() => {
      this.started = false;
      localStorage.setItem("showLogoutMessage", "1");

      // verificam daca avem setat mesajul
      if (!localStorage.getItem("sessionExpiredMessage")) {
        localStorage.setItem("sessionExpiredMessage", "Sesiunea a expirat. Va rugam sa va autentificati din nou.");
      }

      // localStorage.setItem("showLogoutMessage", "1");
      if (!this.isLandingPage) {
        this.authenticationService.clientLogout(true);
      } else {
        this.authenticationService.clientLandingLogout();
      }
    });
  }
}
